import React from 'react';
import PropTypes from 'prop-types';
import { AnimatedElement } from '../../animated-element';
import { AmbientVideo } from '../../ambient-video';
import { isMobile } from '../../../utils/adaptive';
import { Container, Headline, SocialContainer } from '../styles/imageWithText.style';
import { SVGIcon } from '../../../utils/socialSvg';

const propTypes = {
  image: PropTypes.object,
  text: PropTypes.string,
  showSocial: PropTypes.bool,
};

const defaultProps = {
  image: {
    file: {},
  },
  text: '',
  showSocial: false,
};

/**
 * ImageWithText Component
 */
class ImageWithText extends React.Component {
  /**
   * News ImageWithText Constructor
   * @param {object} props Incoming Props
   */
  constructor(props) {
    super(props);
    this.state = {
      isMobileLocal: false,
    };
  }

  /**
   * Determine if mobile components should be used
   */
  componentDidMount() {
    if (isMobile()) {
      this.setState({ isMobileLocal: true });
    }
  }

  /**
   * Renders an ImageWithText Component
   * @returns {XML} ImageWithText Component
   */
  render() {
    const {
      image, text, showSocial, videoId,
    } = this.props;
    const { isMobileLocal } = this.state;

    const isVideo = !!videoId;
    const container = (
      <Container isVideo={isVideo}>
        {isVideo && <AmbientVideo videoId={videoId} />}
        <Headline isVideo={isVideo}>
          {showSocial && isMobileLocal ? 'Follow Us' : text}
          {showSocial ? (
            <SocialContainer>
              <a href="https://www.facebook.com/xfl/" className="social-facebook" target="blank">
                {SVGIcon('facebook')}
              </a>
              <a href="https://www.instagram.com/xfl/" className="social-instagram" target="blank">
                {SVGIcon('instagram')}
              </a>
              <a href="https://twitter.com/xfl2020" className="social-twitter" target="blank">
                {SVGIcon('twitter')}
              </a>
            </SocialContainer>
          ) : null}
        </Headline>
      </Container>
    );

    const animatedElement = (
      <AnimatedElement data={{ image }} animationType="PARALLAX">
        {container}
      </AnimatedElement>
    );

    if (isVideo) {
      return container;
    }
    return animatedElement;
  }
}

ImageWithText.propTypes = propTypes;
ImageWithText.defaultProps = defaultProps;

export default ImageWithText;



// WEBPACK FOOTER //
// ./src/components/dividers/components/imageWithText.js